import React, { Component } from "react";
import { withRouter } from "react-router";
import { withUser } from "@unifiedpatents/sso";
import { Card, Form, Button, Input, Collapse } from "antd";
const FormItem = Form.Item;
const Panel = Collapse.Panel;
import QuickLinks from "./quick-links";
import DateRangePicker from "../common/date-range-picker";
import MultiSelect from "../common/multi-select";
import FullTextHelp from "../common/full-text-help";
import { getDistinctValues } from "../../services/api-ptab";
import { keepOnlyPTABQueryStrings, fromExactMatchQueryString, toExactMatchQueryString } from "../../helpers/url";

const CASE_PHASE_ITEMS = ["Pre-Institution", "Post-Institution"];
const CASE_STATUS_ITEMS = [
  "Pending",
  "Not Instituted - All",
  "Not Instituted - Merits",
  "Not Instituted - Procedural",
  "Terminated - All",
  "Terminated - Final Written Decision",
  "Terminated - Adverse Judgment",
  "Terminated - Settlement",
  "Terminated - Procedural Termination"
];
const TECH_CENTERS = ["1600", "1700", "2100", "2400", "2600", "2800", "2900", "3600", "3700"];
const INDUSTRIES = ["T", "M", "O"];
const PO_ENTITY_TYPES = ["NPE (Patent Assertion Entity)", "NPE (Small Company)", "NPE (Individual)", "University", "Operating Company", "Gov/NGO/Non-Profit"];
const CASE_TYPES = ["IPR", "CBM", "PGR", "DER"];
const CLAIM_OUTCOME_AT_INSTITUTION = ["No Claims Instituted", "Mixed Results", "All Claims Instituted"];
const CLAIM_OUTCOME_AT_FWD = ["All Claims Unpatentable", "Mixed Results", "All Claims Patentable"];
const FILING_TYPES = [
  "Amended Petition",
  "Final Decision",
  "Institution Decision",
  "Joinder Decision",
  "Rehearing Decision",
  "Request for Rehearing",
  "Request for Adverse Judgment",
  "Motion for Joinder",
  "Motion to Amend",
  "Motion to Terminate",
  "Opposition to Amendment",
  "Reply to Opposition",
  "Notice of Appeal",
  "Conduct of Proceeding",
  "Non-Final Judgment",
  "Trial Hearing Order"
];

const INDUSTRY_MAP = {
  T: "High-Tech (T)",
  M: "Medical (M)",
  O: "Other (O)"
};
const TECH_CENTER_MAP = {
  1600: "1600: Biotechnology and Organic Chemistry",
  1700: "1700: Chemical and Materials Engineering",
  2100: "2100: Computer Architecture, Software, and Information Security",
  2400: "2400: Computer Networks, Multiplex communication, Video Distribution, and Security",
  2600: "2600: Communications",
  2800: "2800: Semiconductors, Electrical and Optical Systems and Components",
  2900: "2900: Designs",
  3600: "3600: Transportation,Construction, Electronic Commerce, Agriculture, National Security and License & Review",
  3700: "3700: Mechanical Engineering, Manufacturing, Products"
};
const DD_STATUTES_MAP = { "314A": "§ 314(a)", "325D": "§ 325(d)" };
export const PET_TYPE_MAP = {
  Loc: "Large Operating Company",
  Sme: "SME",
  Up: "Unified Patents",
  Da: "Defensive Aggregators",
  O: "Other",
  G: "Government",
  U: "University"
};

const propsToStates = q => ({
  // convert url query to states
  caseNumber: q.case_number,
  caseStatus: q.up_status ? (q.up_substatus ? q.up_status + " - " + q.up_substatus : q.up_status) : undefined,
  casePhase: q.up_institution_phase,
  patentNumber: q["patent.patent_number"],
  techCenter: q.ptab_tech_center,
  industry: fromExactMatchQueryString(q.up_industry),
  poEntityType: q.up_po_type,
  petEntityType: fromExactMatchQueryString(q.up_pet_type),
  filingDate: q.filing_date,
  instDate: q.up_institution_date,
  termDate: q.up_termination_date,
  petitioner: q["petitioners"],
  petitionerLawfirm: q["lawfirms.petitioner"],
  authorJudge: q["judges.author"],
  patentOwner: q["patent_owners"],
  patentOwnerLawfirm: q["lawfirms.patent_owner"],
  panelJudge: q["judges.panel"],
  fullText: q["filings.full_text"],
  filingType: q["filings.up_type"],
  caseType: q.type,
  claimOutcomeAtInstitution: q.claim_outcome_at_institution,
  claimOutcomeAtFWD: q.claim_outcome_at_fwd,
  isJoinedCase: q.is_joined_case,
  ddStatutes: q.discretionary_denial_statutes,
  ddRefs: q.discretionary_denial_refs,
  errors: q.errors
});

const stateKey2Field = {
  caseNumber: "case_number",
  patentNumber: "patent.patent_number",
  petitioner: "petitioners",
  petitionerLawfirm: "lawfirms.petitioner",
  authorJudge: "judges.author",
  patentOwner: "patent_owners",
  patentOwnerLawfirm: "lawfirms.patent_owner",
  panelJudge: "judges.panel",
  errors: "errors",
  petEntityType: "up_pet_type",
  ddStatutes: "discretionary_denial_statutes",
  ddRefs: "discretionary_denial_refs"
};

class CasesToolbarFilters extends Component {
  state = {
    ...propsToStates(this.props.location.query)
  };

  componentDidMount() {
    this._timeout = null;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(propsToStates(nextProps.location.query));
  }

  render() {
    const resetButton = (
      <Button size="small" onClick={this._onClearClick}>
        {"Reset"}
      </Button>
    );
    const fullTextLabel = (
      <span>
        {"FULL TEXT "}
        <FullTextHelp />
      </span>
    );
    return (
      <Card title="PTAB" extra={resetButton} bodyStyle={{ padding: 1 }}>
        <Form layout="vertical">
          <Collapse defaultActiveKey={["links", "basic"]} bordered={false}>
            <Panel header="QUICK LINKS" key="links">
              <QuickLinks />
            </Panel>
            <Panel header="BASIC" key="basic">
              <FormItem label={fullTextLabel}>
                <Input value={this.state["fullText"]} placeholder="e.g. troll" onChange={e => this.setState({ fullText: e.target.value })} onPressEnter={this._onApplyClick} />
              </FormItem>
              {this.renderSelectFormItem("caseNumber", "CASE", "e.g. IPR2012-00001")}
              {this.renderSelectFormItem("caseType", "TYPE", "e.g. IPR", CASE_TYPES)}
              {this.renderSelectFormItem("caseStatus", "STATUS", "e.g. Pending", CASE_STATUS_ITEMS, undefined, "default")}
              {this.renderSelectFormItem("casePhase", "PHASE", "e.g. Post-Institution", CASE_PHASE_ITEMS, undefined, "default")}
              {this.renderSelectFormItem("patentNumber", "PATENT", "e.g. 8700996")}
              {this.renderSelectFormItem("techCenter", "TECH CENTER", "e.g. 2600", TECH_CENTERS, v => (v ? TECH_CENTER_MAP[v] : v))}
              {this.renderSelectFormItem("industry", "INDUSTRY", "e.g. High-Tech (T)", INDUSTRIES, v => (v ? INDUSTRY_MAP[v] : v))}
            </Panel>
            <Panel header="ENTITIES" key="entities">
              {this.renderSelectFormItem("petitioner", "PETITIONER", "e.g. Unified Patents")}
              {this.renderSelectFormItem("patentOwner", "OWNER", "e.g. Uniloc")}
              {this.renderSelectFormItem("petitionerLawfirm", "PET. COUNSEL", "e.g. Finnegan")}
              {this.renderSelectFormItem("patentOwnerLawfirm", "P.O. COUNSEL", "e.g. Sheppard")}
              {this.renderSelectFormItem("petEntityType", "PET. ENTITY TYPE", "e.g. SME", undefined, v => (v ? PET_TYPE_MAP[v] : v))}
              {this.renderSelectFormItem("poEntityType", "P.O. ENTITY TYPE", "e.g. Operating Company", PO_ENTITY_TYPES)}
              {this.renderSelectFormItem("authorJudge", "AUTHOR JUDGE", "e.g. Thomas L. Giannetti")}
              {this.renderSelectFormItem("panelJudge", "PANEL JUDGE", "e.g. Kevin F. Turner")}
            </Panel>
            <Panel header="DATES" key="dates">
              {this.renderDateFormItem("filingDate", "FILING DATE")}
              {this.renderDateFormItem("instDate", "INSTITUTION DATE")}
              {this.renderDateFormItem("termDate", "TERMINATION DATE")}
            </Panel>
            <Panel header="ADVANCED" key="advanced" disabled={!this.props.user.status.canAccessData}>
              {this.renderSelectFormItem("ddStatutes", "DISCRETIONARY DENIAL STATUTES", "e.g. § 314(a)", undefined, v => (v ? DD_STATUTES_MAP[v] : v))}
              {this.renderSelectFormItem("ddRefs", "§ 314(a) GROUNDS", "e.g. NHK Spring / Fintiv")}
              {this.renderSelectFormItem("claimOutcomeAtInstitution", "INSTITUTION OUTCOMES", "e.g. All Claims Instituted", CLAIM_OUTCOME_AT_INSTITUTION, undefined, "default")}
              {this.renderSelectFormItem("claimOutcomeAtFWD", "FWD OUTCOMES", "e.g. All Claims Unpatentable", CLAIM_OUTCOME_AT_FWD, undefined, "default")}
              {this.renderSelectFormItem("isJoinedCase", "JOINED", "e.g. true", ["true", "false"], undefined, "default")}
            </Panel>
            {this.props.user.status.isAdmin ? (
              <Panel header="ADMIN" key="admin" disabled={!this.props.user.status.isAdmin}>
                {this.renderSelectFormItem("filingType", "HAS FILING TYPE", "e.g. Request for Rehearing", FILING_TYPES, undefined, "default")}
                {this.renderSelectFormItem("errors", "POTENTIAL ERRORS", "e.g. Pending But Old")}
              </Panel>
            ) : null}
          </Collapse>
        </Form>
      </Card>
    );
  }

  renderSelectFormItem = (key, label, placeholder, options, valueRenderer, mode) => (
    <Form.Item label={label}>
      <MultiSelect
        value={this.state[key]}
        onChange={this._updateState(key)}
        options={options}
        optionApiCall={options ? undefined : val => getDistinctValues(stateKey2Field[key], val)}
        optionRender={valueRenderer}
        placeholder={placeholder}
        mode={mode}
      />
    </Form.Item>
  );

  renderDateFormItem = (key, label) => (
    <Form.Item label={label}>
      <DateRangePicker value={this.state[key]} onChange={this._updateState(key)} allowClear={true} />
    </Form.Item>
  );

  _updateState = field => {
    return val =>
      this.setState(
        {
          [field]: val
        },
        this._onApplyClick
      );
  };

  _onClearClick = () => {
    this.props.router.push({
      pathname: this.props.location.pathname,
      query: {
        sort: this.props.location.query.sort
      }
    });
    this.setState(propsToStates({}));
  };

  _onApplyClick = () => {
    let caseStatusArr = this.state.caseStatus ? this.state.caseStatus.split(" - ") : [];
    this.props.router.push({
      pathname: this.props.location.pathname,
      query: keepOnlyPTABQueryStrings({
        up_institution_phase: this.state.casePhase,
        up_status: caseStatusArr[0],
        up_substatus: caseStatusArr[1] === "All" ? undefined : caseStatusArr[1],
        case_number: this.state.caseNumber,
        "patent.patent_number": this.state.patentNumber,
        ptab_tech_center: this.state.techCenter,
        up_industry: toExactMatchQueryString(this.state.industry),
        up_po_type: this.state.poEntityType,
        up_pet_type: toExactMatchQueryString(this.state.petEntityType),
        filing_date: this.state.filingDate,
        up_institution_date: this.state.instDate,
        up_termination_date: this.state.termDate,
        petitioners: this.state.petitioner,
        "lawfirms.petitioner": this.state.petitionerLawfirm,
        "judges.author": this.state.authorJudge,
        patent_owners: this.state.patentOwner,
        "lawfirms.patent_owner": this.state.patentOwnerLawfirm,
        "judges.panel": this.state.panelJudge,
        "filings.full_text": this.state.fullText,
        "filings.up_type": this.state.filingType,
        type: this.state.caseType,
        claim_outcome_at_institution: this.state.claimOutcomeAtInstitution,
        claim_outcome_at_fwd: this.state.claimOutcomeAtFWD,
        is_joined_case: this.state.isJoinedCase,
        discretionary_denial_statutes: this.state.ddStatutes,
        discretionary_denial_refs: this.state.ddRefs,
        errors: this.state.errors,
        sort: this.props.location.query.sort ? this.props.location.query.sort : "-filing_date"
      })
    });
  };
}

export default withUser(withRouter(CasesToolbarFilters));
